import { FullPageMessage } from "./FullPageMessage";

export function ErrorDisplay({ error }: { error: unknown }) {
  const errorMessage = error instanceof Error ? error.message : String(error);

  return <FullPageMessage title="Error" message={errorMessage} />;
}
